import { render } from "./NotificationButton.vue?vue&type=template&id=48dda9fa&scoped=true"
import script from "./NotificationButton.vue?vue&type=script&lang=js"
export * from "./NotificationButton.vue?vue&type=script&lang=js"

import "./NotificationButton.vue?vue&type=style&index=0&id=48dda9fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dda9fa"]])

export default __exports__